import { TOCSelectorPageItem } from '@deckManagement/types/TableOfContentsSelector.types';
import { generateTocSelectorPageItems } from '@utils/deckHelpers';
import { useMemo } from 'react';
import { EnhancedTOCEntry } from 'types/TOCContext.types';

/**
 * Hook to generate the configuration needed to display a grouped TOC item listing in the TOC Selector component
 * @param deckId - The deckId to use for generating the page items
 * @param getTocItemsByGroup - A function to retrieve the TOC items grouped by a group key (e.g. 'active-approved', 'active-modified, 'inactive')
 * @returns - An object containing the current page items and the group lookup values
 */
const useTocSelectorConfig = (deckId: string, getTocItemsByGroup: () => Map<string, EnhancedTOCEntry[]>) => {
  return useMemo(() => {
    const currPageItems: Array<TOCSelectorPageItem> = [];
    const currTocItemsByGroup = getTocItemsByGroup();
    const groupLookupValues: Record<string, Set<string>> = {};
    currTocItemsByGroup.forEach((currTocItems, currGroupKey) => {
      currPageItems.push(...generateTocSelectorPageItems(deckId, currTocItems));
      // Generate the helper lookup values object
      groupLookupValues[currGroupKey] = new Set<string>(currTocItems.map((item) => item.page_id!));
    });

    return {
      currPageItems,
      groupLookupValues,
    };
  }, [deckId, getTocItemsByGroup]);
};

export default useTocSelectorConfig;
